module.exports = __webpack_public_path__ + "cf44a1b0ced9060d2458982a3ab8b42c.MP3";